<div class="image-lightbox-container fixed inset-0 bg-black bg-opacity-95 z-50 flex items-center justify-center">
    <!-- Header com ações -->
    <div class="absolute top-0 left-0 right-0 z-10 flex items-center justify-between p-4 bg-gradient-to-b from-black/50 to-transparent">
        <div class="flex items-center gap-2">
            <span *ngIf="images.length > 1" class="text-white text-sm font-medium">
                {{ currentIndex + 1 }} / {{ images.length }}
            </span>
        </div>
        <div class="flex items-center gap-2">
            <button
                mat-icon-button
                (click)="openInNewTab()"
                class="text-white hover:bg-white/20"
                [matTooltip]="'Abrir em nova aba'"
            >
                <mat-icon [svgIcon]="'heroicons_outline:arrow-top-right-on-square'"></mat-icon>
            </button>
            <button
                mat-icon-button
                (click)="download()"
                class="text-white hover:bg-white/20"
                [matTooltip]="'Baixar'"
            >
                <mat-icon [svgIcon]="'heroicons_outline:arrow-down-tray'"></mat-icon>
            </button>
            <button
                mat-icon-button
                (click)="close()"
                class="text-white hover:bg-white/20"
                [matTooltip]="'Fechar (ESC)'"
            >
                <mat-icon [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
            </button>
        </div>
    </div>

    <!-- Navegação anterior -->
    <button
        *ngIf="canNavigatePrevious"
        mat-icon-button
        (click)="previousImage()"
        class="absolute left-4 top-1/2 -translate-y-1/2 z-10 text-white hover:bg-white/20 rounded-full p-2"
        [matTooltip]="'Anterior (←)'"
    >
        <mat-icon [svgIcon]="'heroicons_outline:chevron-left'" class="text-4xl"></mat-icon>
    </button>

    <!-- Navegação próxima -->
    <button
        *ngIf="canNavigateNext"
        mat-icon-button
        (click)="nextImage()"
        class="absolute right-4 top-1/2 -translate-y-1/2 z-10 text-white hover:bg-white/20 rounded-full p-2"
        [matTooltip]="'Próxima (→)'"
    >
        <mat-icon [svgIcon]="'heroicons_outline:chevron-right'" class="text-4xl"></mat-icon>
    </button>

    <!-- Área da imagem -->
    <div class="flex-1 flex items-center justify-center p-4 overflow-auto" (click)="close()">
        <div class="relative max-w-full max-h-full" (click)="$event.stopPropagation()">
            <!-- Loading -->
            <div *ngIf="loading" class="flex items-center justify-center w-full h-96">
                <mat-spinner diameter="48" class="text-white"></mat-spinner>
            </div>

            <!-- Erro -->
            <div *ngIf="imageError && !loading" class="flex flex-col items-center justify-center w-full h-96 text-white">
                <mat-icon [svgIcon]="'heroicons_outline:exclamation-triangle'" class="text-6xl mb-4"></mat-icon>
                <p class="text-lg">Erro ao carregar imagem</p>
            </div>

            <!-- Imagem -->
            <img
                *ngIf="currentImageUrl && !loading && !imageError"
                [src]="currentImageUrl"
                [alt]="data.alt || 'Imagem ampliada'"
                (load)="onImageLoad()"
                (error)="onImageError()"
                class="max-w-full max-h-[90vh] object-contain select-none"
                [style.transform]="'scale(' + zoomLevel + ')'"
                [style.transition]="'transform 0.2s ease-out'"
                draggable="false"
            />
        </div>
    </div>

    <!-- Footer com controles de zoom -->
    <div class="absolute bottom-0 left-0 right-0 z-10 flex items-center justify-center gap-4 p-4 bg-gradient-to-t from-black/50 to-transparent">
        <button
            mat-icon-button
            (click)="zoomOut()"
            class="text-white hover:bg-white/20"
            [disabled]="zoomLevel <= 0.5"
            [matTooltip]="'Diminuir zoom (-)'"
        >
            <mat-icon [svgIcon]="'heroicons_outline:minus'"></mat-icon>
        </button>
        <span class="text-white text-sm font-medium min-w-[60px] text-center">
            {{ (zoomLevel * 100).toFixed(0) }}%
        </span>
        <button
            mat-icon-button
            (click)="zoomIn()"
            class="text-white hover:bg-white/20"
            [disabled]="zoomLevel >= 5"
            [matTooltip]="'Aumentar zoom (+)'"
        >
            <mat-icon [svgIcon]="'heroicons_outline:plus'"></mat-icon>
        </button>
        <button
            mat-icon-button
            (click)="resetZoom()"
            class="text-white hover:bg-white/20"
            [disabled]="zoomLevel === 1"
            [matTooltip]="'Resetar zoom'"
        >
            <mat-icon [svgIcon]="'heroicons_outline:arrows-pointing-out'"></mat-icon>
        </button>
    </div>
</div>

